(function () {
  function init() {
    var wrapper = document.querySelector('.product-videos-wrapper');
    if (!wrapper) return;

    var videos = Array.prototype.slice.call(
      wrapper.querySelectorAll('.product-video-element')
    );
    if (!videos.length) return;

    function controlBtn(idx) {
      return wrapper.querySelector('.product-video-control[data-control-index="' + idx + '"]');
    }

    function updateIcon(idx) {
      var btn = controlBtn(idx);
      if (!btn) return;
      var video = videos[idx];
      var icon = btn.querySelector('.product-video-control-icon');
      if (icon) icon.textContent = video.paused ? '\u25B6' : '\u23F8';
      if (video.paused) btn.classList.remove('playing'); else btn.classList.add('playing');
    }

    /* Force the first frame to paint so a paused video isn't black. */
    function paintFirstFrame(video) {
      function seek() {
        video.removeEventListener('loadedmetadata', seek);
        try { video.currentTime = 0.1; } catch (e) {}
      }
      if (video.readyState >= 1) {
        try { video.currentTime = 0.1; } catch (e) {}
      } else {
        video.addEventListener('loadedmetadata', seek);
      }
    }

    function stopAllExcept(idx) {
      videos.forEach(function (v, i) {
        if (i === idx) return;
        try { v.pause(); } catch (e) {}
        updateIcon(i);
      });
    }

    function playIndex(idx) {
      if (idx < 0 || idx >= videos.length) return;
      var video = videos[idx];
      stopAllExcept(idx);
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      updateIcon(idx);
    }

    function toggle(idx) {
      var video = videos[idx];
      if (video.paused) { playIndex(idx); } else { video.pause(); updateIcon(idx); }
    }

    videos.forEach(function (video, idx) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.controls = false;
      video.load();
      paintFirstFrame(video);

      video.addEventListener('ended', function () {
        var next = idx + 1;
        if (next < videos.length) { playIndex(next); } else { updateIcon(idx); }
      });
      video.addEventListener('play', function () { updateIcon(idx); });
      video.addEventListener('pause', function () { updateIcon(idx); });

      /* Tap anywhere on the video (or the button) to toggle play/pause. */
      var media = video.closest('.product-video-media') || video.parentNode;
      media.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(idx);
      });

      updateIcon(idx);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
